var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchLinedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1098 11.1098C11.2563 10.9634 11.4937 10.9634 11.6402 11.1098L14.7652 14.2348C14.9116 14.3813 14.9116 14.6187 14.7652 14.7652C14.6187 14.9116 14.3813 14.9116 14.2348 14.7652L11.1098 11.6402C10.9634 11.4937 10.9634 11.2563 11.1098 11.1098Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35714 2.375C4.60558 2.375 2.375 4.60558 2.375 7.35714C2.375 10.1087 4.60558 12.3393 7.35714 12.3393C8.73541 12.3393 9.98236 11.7801 10.8847 10.8754C11.784 9.97373 12.3393 8.73065 12.3393 7.35714C12.3393 4.60558 10.1087 2.375 7.35714 2.375ZM1.625 7.35714C1.625 4.19137 4.19137 1.625 7.35714 1.625C10.5229 1.625 13.0893 4.19137 13.0893 7.35714C13.0893 8.93718 12.4495 10.3685 11.4158 11.405C10.3784 12.4451 8.94267 13.0893 7.35714 13.0893C4.19137 13.0893 1.625 10.5229 1.625 7.35714Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchLinedBlack);
export default __webpack_public_path__ + "static/media/ic_search_lined_black.41ffe964c1c3335c821230580dde8309.svg";
export { ForwardRef as ReactComponent };